export default "__VITE_ASSET__LotqecrW__"